import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PromotionBlock } from '../../../../PromotionBlock/PromotionBlock.js';
import { BannerRecommendationAction } from '../../../types.js';
import { convertBannerRecommendationInfo } from '../../../utils/mappers.js';

const BannerRecommendation = /*#__PURE__*/ React.forwardRef(({ recommendation , onClick , className , tabIndex  }, ref)=>{
    const info = convertBannerRecommendationInfo(recommendation);
    if (!info) return null;
    let link;
    if (info.action && info.action === BannerRecommendationAction.Link) {
        link = info.link;
    }
    return /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({
        ref: ref,
        id: `banner-recommendation_${info.title}`,
        /**
         * CTA will not show if there's no label. This is not clear from the type.
         */ ctaLabel: (link === null || link === void 0 ? void 0 : link.label) || '',
        size: "small",
        links: swcHelpers.objectSpread({}, link, {
            style: ''
        })
    }, info, {
        onClick: onClick,
        className: className,
        tabIndex: tabIndex
    }));
});

export { BannerRecommendation };
//# sourceMappingURL=BannerRecommendation.js.map
